import React from 'react'
import styled from 'styled-components'

const SectionWrapper = styled.section`
  display: none;
  overflow: hidden;
  width: 100%;
  padding: 100px 0 140px;
  @media screen and (max-width: 800px) {
    padding: 90px 0;
  }
`
const SectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 86%;
  max-width: var(--max-width);
  margin: 0 auto;
  color: var(--text);
  @media screen and (max-width: 800px) {
    flex-direction: column;
    width: calc(100% - 50px);
    margin: 0 25px;
  }
`
const LeftColumn = styled.div`
  width: calc(100% - 420px);
  padding-right: 80px;
  @media screen and (max-width: 800px) {
    width: 100%;
    padding-right: 0;
  }
  h1 {
    line-height: 1.25;
  }
  h3 {
    font-size: var(--fz-lg);
    color: #c1c1c1;
    line-height: 1.5;
    font-weight: 400;
  }
  .button {
    display: inline-block;
    cursor: pointer;
    width: auto;
    margin: 30px 0 40px 0;
    padding: 14px 28px 17px;
    text-align: center;
    color: var(--white);
    font-family: var(--font-condensed);
    font-size: var(--fz-lg);
    font-weight: 500;
    line-height: 1;
    border-radius: 4px;
    transition: var(--transition);
    background-color: var(--secondary);
    box-shadow: 0 0 20px 0 rgb(0 0 0 / 10%);
    &:hover {
      color: var(--white);
      background-color: var(--grey-hover);
    }
  }
`
const RightColumn = styled.div``

const ServiceDesign = () => {
  return (
    <SectionWrapper>
      <SectionContainer>
        <LeftColumn>
          <h2>Set Up</h2>
          <p>modules here...</p>
        </LeftColumn>
        <RightColumn></RightColumn>
      </SectionContainer>
    </SectionWrapper>
  )
}

export default ServiceDesign
